import { ReactNode } from "react"
import { makeStyles } from "tss-react/mui"
import { Box, Stack, Typography } from "@mui/material"
import { Dinero } from "dinero.js"

import { useMoney } from "../../../modules/currency/useMoney"

const useStyles = makeStyles()((theme) => ({
    itemRow: {
        display: "grid",
        gridTemplateColumns: "subgrid",
        gridColumn: "1 / -1",
        alignItems: "start",
        "& + &": {
            marginTop: ".875rem",
            paddingTop: ".875rem",
            borderTop: `1px solid ${theme.palette.tailwind.slate[200]}`,
        },
    },
    itemNameText: {
        color: theme.palette.tailwind.slate[950],
    },
    itemQty: {
        color: theme.palette.tailwind.slate[600],
        textAlign: "right",
        whiteSpace: "nowrap",
    },
    itemAmount: {
        fontWeight: 700,
        color: theme.palette.tailwind.slate[950],
        textAlign: "right",
        whiteSpace: "nowrap",
    },
}))

type OrderLineRowProps = Readonly<{
    name: string
    quantity: number
    unitPrice: Dinero<number>
    total: Dinero<number>
    moneyFactory: ReturnType<typeof useMoney>
    children?: ReactNode
}>

export function OrderLineRow({ name, quantity, unitPrice, total, moneyFactory, children }: OrderLineRowProps) {
    const { classes } = useStyles()

    return (
        <Box className={classes.itemRow}>
            <Stack spacing=".25rem">
                <Typography variant="body1" className={classes.itemNameText}>
                    {name}
                </Typography>
                {children}
            </Stack>
            <Typography variant="body1" className={classes.itemQty}>
                {`${quantity} x ${moneyFactory.formatAsNumber(unitPrice)}`}
            </Typography>
            <Typography variant="body1" className={classes.itemAmount}>
                {moneyFactory.formatAsNumber(total)}
            </Typography>
        </Box>
    )
}
